import { render } from "./eligiblityView.vue?vue&type=template&id=2389769c"
import script from "./eligiblityView.vue?vue&type=script&lang=js"
export * from "./eligiblityView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__